import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	panelTitle: {
		id: 'servicedesk-insight-object-view.avatar-panel.panel-title',
		defaultMessage: 'Avatar',
		description: 'Title for the Avatar panel',
	},
	avatarImageAlt: {
		id: 'servicedesk-insight-object-view.avatar-panel.avatar-image-alt',
		defaultMessage: 'Avatar',
		description: 'Alternative text to show for when the avatar image fails to load',
	},
});
